import { render } from "./COGSAccountPosting.vue?vue&type=template&id=6f50ddf7&scoped=true"
import script from "./COGSAccountPosting.vue?vue&type=script&lang=js"
export * from "./COGSAccountPosting.vue?vue&type=script&lang=js"

import "./COGSAccountPosting.vue?vue&type=style&index=0&id=6f50ddf7&scoped=true&lang=css"

import exportComponent from "D:\\DockerProjects\\armt_pos_v2_docker\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f50ddf7"]])

export default __exports__